// extracted by mini-css-extract-plugin
module.exports = {"VerificationWarning":"VerificationWarning_VerificationWarning__3_ymF","Content":"VerificationWarning_Content__1gH0B","CloseIcon":"VerificationWarning_CloseIcon__vLmYg"};